/** flixit only (flixit-be): the Pauly API dropped a product's additional costs in PAUL-3045. */
export interface ProductAdditionalCost {
  name: string;
  amount: number;
  id: string;
  tax_id: string;
  description: string;
  general_ledger_account_id: string;
  general_ledger_account_name: string;
  additional_cost_type: AdditionalCostType;
}

export enum AdditionalCostType {
  Other = 0,
  ServiceCharges = 1,
  PlasticTax = 2,
  ReservationCosts = 3,
}
